import gql from 'graphql-tag';

export default () => gql`
  query {
    getTenantUsageIndicator(dummy: "") {
      tenantDetailList {
        name
        value
      }
    }
  }
`;
